exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#assessmentIframe[data-v-44e14e3c] {\n  width: 100%;\n  height: calc(100vh - 130px);\n}\n", ""]);
